module.exports = __webpack_public_path__ + "static/Lunasol-logo-43ccc5774d359bc6395f3146b3acfd99.png";